<template lang="pug">
  .height-100
    .modal.is-active(
      key="modal-editar"
      :class="{'modal-sidebar-desktop-open': showSidebarDesktop }"
      v-if="mostrarConfirmacionEliminar"
      )
      transition(
        name='fade',
        tag="div",
        )
        confirmar-accion-overlay(
          @close="mostrarConfirmacionEliminar = false"
          @do="eliminar()"
        )
          span(slot="title") {{ confirmacionEliminarTitulo }}
          span(slot="information") {{ confirmacionEliminarDescripcion }}
          span(slot="primaryAction")
            template(v-if="isSendingEliminar")
              | Eliminando...
            template(v-else)
              | Eliminar
    transition(name="fade" v-if="showModalEditar")
      .modal.is-active(key="modal-editar" :class="{'modal-sidebar-desktop-open': showSidebarDesktop }")
        transition(name='fade-quick')
          .overlay-class(
            v-if="mostrarModalAdjuntar"
          )
            upload-image(
              name="materiales_",
              folder="curso_virtual_material",
              @save="guardarAdjunto"
              @close="closeModalAdjuntar"
            )
              span(slot="title") Adjuntar archivo
              span(slot="explanation") Adjunta el archivo  deseado
              i.fa.fa-file(slot="topIcon")
        .modal-background(@click="closeModalAdd()")
        .card
          header.modal-card-head.display-flex
            p.flex-1
              span(v-if="id") Editar material
              span(v-else) Crear material
            span.icon.close(
                @click="$emit('close')"
              )
                i.fa.fa-close
          .card-content
            .title
              .display-flex.fdc
                .control.margin-bottom-10.flex-1
                  p.margin-bottom-5 Título
                  input.input(
                    type="text",
                    v-model="titulo"
                    maxlength="100"
                    :disabled="isLoading"
                  )
                .control.margin-bottom-10
                  p.margin-bottom-5 Descripción
                  textarea.textarea.w-300(
                    v-model="descripcion"
                    :disabled="isLoading"
                  )
              .text-center
                template
                  .mb-5.mt-5.adjunto(v-if="pathDoc")
                    a.button.is-small(:href="pathDoc", target="_blank")
                      span.icon.is-small
                        i.fa.fa-paperclip.is-small
                      span Ver adjunto
                    span.icon.color-red.margin-left-5.cursor-pointer(@click="borrarArchivo()", tittle="Borrar adjunto")
                      i.fa.fa-trash
                  div(v-else)
                    button.button.is-small.is-primary(@click="openModalAdjuntar")
                      span.icon.is-small
                        i.fa.fa-upload.is-small
                      span Adjuntar
          footer.card-footer
            a.card-footer-item.is-success(@click="guardar()")
              span(v-if="isSaving") Guardando...
              span(v-else) Guardar
            a.card-footer-item( @click="closeModalAdd()")
              strong Cancelar
    .title.pt-5
      span Materiales
    .text-center(v-if="modulo !== 'alumno'")
      button.button.is-small.margin-right-5.is-primary(@click="abrirModalEditar()")
        span.icon.is-small
          i.fa.fa-plus
        span Nuevo
    .body
      .is-loading(v-if="isLoading")
        .icon
          i.fa.fa-spinner.fa-spin
      .information(v-else)
        .is-mobile
          .data
            .usuario(
              v-for="(o, index) in lista"
              :key="index"
              @dblclick="abrirModalEditar(o.id)"
            )
              .display-flex.aic
                .display-flex.fdc.flex-1
                  strong.flex(v-if="modulo !== 'alumno'") {{ o.titulo | truncateText(20) }}
                  strong.flex(v-else) {{ o.titulo }}
                  .subtitle(v-if="o.descripcion")
                    span.italic.flex(v-if="modulo !== 'alumno'") {{ o.descripcion | truncateText }}
                    span.italic.flex(v-else v-html="convertirSaltosDeLinea(o.descripcion)")
                .contenedor-acciones.display-flex.aic(v-if="o.pathDoc || modulo !== 'alumno'")
                  a.button.is-small.m-2(v-if="o.pathDoc" :href="o.pathDoc" target="_blank")
                    span.icon.is-small
                      i.fa.is-small(:class="[getFileIcon(o.extension).i]")
                  template(v-if="modulo !== 'alumno'")
                    button.button.is-small.m-2(@click="abrirModalEditar(o.id)")
                      span.icon.is-small
                        i.fa.fa-pencil-square-o
                    button.button.is-small.m-2.is-danger(@click="confirmarEliminar(o)")
                      span.icon.is-small
                        i.fa.fa-trash
        div(v-if="!isLoading && lista.length === 0")
          .message.is-warning
            .message-body No hay materiales registradas

</template>

<script>
import ComponentConfirmarAccionOverlay from './Component_Confirmar_Accion_Overlay';
import UploadImage from '../components/Component_Upload_Image'
import { apiGet, apiPut, apiPost, notify, deleteFilesServer, apiDelete } from '../util/general'
export default {
  name: 'c_materiales_lista',
  props: {
    type: {
      type: String,
      required: true
    },
    modulo: {
      type: String,
      required: false,
      default: 'gestion'
    },
    fetchURL: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      lista                      : [],
      isLoading                  : false,
      localPath                  : '',
      id                         : '',
      titulo                     : '',
      descripcion                : '',
      pathDoc                    : '',
      extension                  : '',
      showModalEditar            : false,
      mostrarModalAdjuntar       : false,
      isSaving                   : false,
      mostrarConfirmacionEliminar: false,
      icons: {
        pdf: { i: 'fa-file-pdf-o', bg: 'is-danger' },
        doc: { i: 'fa-file-word-o', bg: 'is-primary' },
        docx: { i: 'fa-file-word-o', bg: 'is-primary' },
        xls: { i: 'fa-file-excel-o', bg: 'is-success' },
        xlsx: { i: 'fa-file-excel-o', bg: 'is-success' },
        jpg: { i: 'fa-file-image-o', bg: 'is-warning' },
        jpeg: { i: 'fa-file-image-o', bg: 'is-warning' },
        png: { i: 'fa-file-image-o', bg: 'is-warning' },
        gif: { i: 'fa-file-image-o', bg: 'is-warning' },
        bmp: { i: 'fa-file-image-o', bg: 'is-warning' },
        tiff: { i: 'fa-file-image-o', bg: 'is-warning' },
        mp4: { i: 'fa-file-video-o', bg: 'is-link' },
        avi: { i: 'fa-file-video-o', bg: 'is-link' },
        mov: { i: 'fa-file-video-o', bg: 'is-link' },
        wmv: { i: 'fa-file-video-o', bg: 'is-link' },
        mp3: { i: 'fa-file-audio-o', bg: 'is-info' },
        wav: { i: 'fa-file-audio-o', bg: 'is-info' },
        ogg: { i: 'fa-file-audio-o', bg: 'is-info' },
        flac: { i: 'fa-file-audio-o', bg: 'is-info' },
        zip: { i: 'fa-file-archive-o', bg: 'is-dark' },
        rar: { i: 'fa-file-archive-o', bg: 'is-dark' },
        '7z': { i: 'fa-file-archive-o', bg: 'is-dark' },
        tar: { i: 'fa-file-archive-o', bg: 'is-dark' },
        gz: { i: 'fa-file-archive-o', bg: 'is-dark' }
      },
      isSendingEliminar:false,
      confirmacionEliminarId:'',
      confirmacionEliminarTitulo:'',
      confirmacionEliminarDescripcion:''
    }
  },
  computed : {
    showSidebarDesktop () {
      return this.$store.getters.showSidebarDesktop
    },
    idCurso () {
      return +this.$route.params.id || +this.$route.params.idCurso
    },
    idClase () {
      return +this.$route.params.idClase
    },
    baseURL () {
      return `/curso/gestion/${this.idCurso}/clase/${this.idClase}/material`
    }
  },
  components: {
    'upload-image': UploadImage,
    'confirmar-accion-overlay' : ComponentConfirmarAccionOverlay
  },
  created () {
  },
  mounted () {
    var vm = this
    if ((vm.type === 'curso' && vm.idCurso) || (vm.type === 'clase' && vm.idClase)) {
      vm.fetch()
    }
  },
  methods: {
    convertirSaltosDeLinea (texto) {
      return texto ? texto.replace(/\n/g, '<br>') : '';
    },
    getFileIcon (extension) {
      // Devuelve el ícono si existe en el objeto `icons`, de lo contrario un valor por defecto
      return this.icons[extension] || { i: 'fa-download', bg: 'is-primary' };
    },
    confirmarEliminar (o) {
      var vm = this
      vm.confirmacionEliminarId = o.id
      vm.confirmacionEliminarTitulo = 'Eliminar material'
      vm.confirmacionEliminarDescripcion = '¿Estás seguro de eliminar el material ' + o.titulo + '?'

      vm.mostrarConfirmacionEliminar = true
    },
    eliminar () {
      var vm = this
      var url = `/curso/gestion/${vm.idCurso}/clase/${vm.idClase}/material/${vm.confirmacionEliminarId}`
      vm.isSendingEliminar = true
      console.log('url :>> ', url);
      apiDelete(vm, url, {}, function (data) {
        notify(vm, 'success', 'Éxito', 'Material eliminado con éxito.')
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isSendingEliminar = false
        vm.mostrarConfirmacionEliminar = false
        vm.fetch()
      })
    },
    setear (obj) {
      Object.assign(this, obj)
    },
    fetch () {
      var vm = this
      vm.isLoading = true
      apiGet(vm, vm.fetchURL || vm.baseURL, { tipo:vm.type, modulo:vm.modulo }, function (data) {
        vm.lista = data.lista
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isLoading = false
        if (vm.lista.length === 0) vm.$emit('close')
      })
    },
    fetchMaterial (showModalEditar) {
      var vm = this
      vm.isLoading = true
      apiGet(vm, `/curso/gestion/${vm.idCurso}/clase/${vm.idClase}/material/${vm.id}`, { tipo:vm.type }, function (data) {
        vm.setear(data.material)
        if (showModalEditar) vm.showModalEditar = true
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isLoading = false
      })
    },
    closeModalAdjuntar () {
      var vm = this
      vm.mostrarModalAdjuntar = false
    },
    openModalAdjuntar () {
      var vm = this
      vm.mostrarModalAdjuntar = true
    },
    guardarAdjunto (fileSubido) {
      var vm = this
      vm.closeModalAdjuntar()
      vm.pathDoc = fileSubido.file.ruta
      vm.extension = fileSubido.file.extension.substring(1)
      vm.localPath = fileSubido.file.localPath
    },
    abrirModalEditar (idMaterial) {
      var vm = this
      if (vm.modulo === 'alumno') return
      if ((vm.type === 'curso' && !vm.idCurso) || (vm.type === 'clase' && !vm.idClase)) {
        vm.closeModalAdd()
        vm.$emit('save')
        return
      }
      if (idMaterial) {
        vm.id          = idMaterial
        vm.fetchMaterial(true)
      } else {
        vm.showModalEditar = true
      }
    },
    closeModalAdd () {
      if (!this.id && this.localPath) {
        this.borrarArchivosNoUtilizados()
      }
      this.showModalEditar = false
      this.limpiarDatos()
    },
    guardar () {
      if (this.id) {
        this.actualizar()
      } else {
        this.insertar()
      }
    },
    insertar () {
      var vm = this
      if (vm.isSaving) return;
      vm.isSaving = true
      var obj = {
        titulo      : vm.titulo,
        descripcion : vm.descripcion,
        pathDoc     : vm.pathDoc,
        extension   : vm.extension,
        tipo        : vm.type
      }
      apiPost(vm, `/curso/gestion/${vm.idCurso}/clase/${vm.idClase}/material/0`, obj, function (data) {
        notify(vm, 'success', 'Éxito', 'Creado correctamente')
        vm.fetch()
        vm.limpiarDatos()
        vm.showModalEditar = false
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isSaving = false
      })
    },
    actualizar () {
      var vm = this
      if (vm.isSaving) return;
      vm.isSaving = true
      var obj = {
        titulo      : vm.titulo,
        descripcion : vm.descripcion,
        pathDoc     : vm.pathDoc,
        extension   : vm.extension,
        tipo        : vm.type
      }
      apiPut(vm, `/curso/gestion/${vm.idCurso}/clase/${vm.idClase}/material/${vm.id}`, obj, function (data) {
        notify(vm, 'success', 'Éxito', 'Actualizado correctamente')
        vm.fetch()
        vm.limpiarDatos()
        vm.showModalEditar = false
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isSaving = false
      })
    },
    limpiarDatos () {
      var vm = this
      vm.id          = ''
      vm.titulo      = ''
      vm.descripcion = ''
      vm.pathDoc     = ''
      vm.extension   = ''
      vm.localPath   = ''
    },
    borrarArchivo () {
      var vm = this
      if (!vm.id && vm.localPath) {
        vm.borrarArchivosNoUtilizados()
      } else {
        vm.pathDoc = ''
        vm.extension = ''
        vm.localPath = ''
      }
    },
    borrarArchivosNoUtilizados () {
      var vm = this
      var obj = {
        archivos: [vm.localPath]
      }
      deleteFilesServer(vm, obj, function (data) {
        notify(vm, 'success', 'Éxito', 'borrado correctamente')
        vm.pathDoc = ''
        vm.extension = ''
        vm.localPath = ''
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>

  .data
    max-height 250px
    overflow-y auto
    scrollbar-width: none; /* Firefox */
    padding 2px
    &::-webkit-scrollbar
      display none // Ocultar barra en Chrome, Safari y navegadores Webkit
    .usuario
      background #fff
      border-radius 3px
      border 1px solid #d6dadc
      border-bottom-color #c4c9cc
      -webkit-box-shadow 0 1px 6px rgba(0,0,0,.15)
      box-shadow 0 1px 6px rgba(0,0,0,.15)
      padding 10px
      margin-bottom 5px
      cursor pointer
      transition all .2s ease
      width 100%
      max-width: 290px
      &:hover
        background-color #edeff0
        margin-left 4px
        -webkit-box-shadow -8px 0 #959da17d
        box-shadow -8px 0 #959da17d
      span.italic
        font-size 14px
        text-align left
      .contenedor-acciones
        padding-left 1em
    .contenedor-box
      >*
        transition all .5s
        width 100%
  .is-mobile
    .is-close
      background-color #ffd6d6 !important
  .contenedor-interno
    .close
      float right
      cursor pointer
      i
        font-size 16px

    .title
      font-size 16px
      // span
      //   font-weight bold
      //   text-transform uppercase

  th
    text-align center

  .row-table
    transition all 0.3s ease
    &.is-close
      background-color #ffd6d6 !important


  .table-row-enter, .table-row-leave-active {
    opacity: 0
    height 0
  }

  .pop-over
    background: #fff;
    border-radius: 3px;
    border: 1px solid #d6dadc;
    border-bottom-color: #c4c9cc;
    -webkit-box-shadow: 0 1px 6px rgba(0,0,0,.15);
    box-shadow: 0 1px 6px rgba(0,0,0,.15);
    position: absolute;
    min-width: 300px
    width: 100%;
    z-index: 70;
    top 0

  .position-relative
    position relative

  .codigo-empleado
    position relative
    .control
      .input-container
        display flex
        align-items center
        .input
          flex 1
          width 100px
        .erase-data
          cursor pointer
          margin-left 5px

  .filtros-container
    padding-bottom 10px
    border-bottom 1px solid #ccc
    .title-filtro
      display flex
      text-align left
      padding-left 10px
      padding-bottom 10px
      margin-bottom 10px
      border-bottom 1px solid #ccc
      .text
        text-transform uppercase
        flex 1
      .caret
        cursor pointer

    .filtros
      margin-bottom 10px
      text-align left
      display flex
      align-items: flex-start;


      .filtro
        display inline-block
        border 1px solid #cccccc
        background-color #f9f9f9
        padding 5px
        margin 5px
        border-radius 3px
        flex 1
        max-width 25%
        .title-singular
          text-align left
          font-weight bold
          user-select: none
        .abierto-cerrado-container
          display flex
          .option
            padding 4px
            border 1px solid #565cde
            color #565cde
            cursor pointer
            transition all 0.3s ease
            height 31.5px

            &.selected
              background-color: #565cde;
              color: #fff;

        .list-container
          padding 0px 10px 0px 10px
          .option
            user-select: none
            cursor pointer
            &.selected
              color #565cde
              font-weight bold

  .boton-container
    button
      margin-left 5px



  .is-loading
    margin-top 10px

  .information
    padding-top 10px

  th
    vertical-align: middle;
  td
    vertical-align: middle;

  td
    .email
      font-size 12px
      color #9a9a9a

  .table
    font-size 13px

  .td-status
    width: 50px;

  .status
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    .circle
      width: 25px;
      height: 25px;
      border-radius: 50%
      transition background ease-in .15s
      border 1px solid #d8d8d8
      background-color #23d160
      &.green
        background-color #23d160
      &.yellow
        background-color #ffdd57
      &.red
        background-color #ff0000
      &.white
        background-color #ffffff

  .status-container-filtro
    display flex
    justify-content center
    align-items center
    .status
      margin 5px
      cursor pointer
      .circle
        transition all ease-in .15s
        width: 30px;
        height: 30px;
      &.selected
        .circle
          border 2px solid #565cde
  .is-mobile
    display block
    .box
      position: relative;
    .status
      position:absolute;
      top: -3px
      right: 5px
      span {
        font-size: 10px;
        color #a5a5a5
        font-weight: bold;
      }
    .descripcion-tipo
      margin-bottom 5px
    .motivo
      word-wrap: break-word;
      background-color: #eff5fb;
      color: #296fa8;
      padding: 10px
    .botones
      display flex
      justify-content center
      margin-top 10px
      .button
        margin-right 5px
        &:last-child
          margin-right 0px
  .modal-sidebar-desktop-open
    width: calc(100% - 180px);
  @media (max-width: 500px)
    .data
      .usuario
        width: 100%;
        max-width: 100%;
        min-width: 100%;
  @media (max-width: 820px)
    .modal-sidebar-desktop-open
      width: 100%;
</style>




// WEBPACK FOOTER //
// c_materiales_lista.vue?1d70e5f2